import Label from 'LuxKit/Label/Label'
import LuxPlusLabelWithModal from 'luxPlus/components/LuxPlusLabelWithModal'
import { isLEOffer } from 'lib/offer/offerTypes'
import { useIntl } from 'react-intl'
import useLuxPlusDisplayedMode from 'luxPlus/hooks/useLuxPlusDisplayedMode'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import styled from 'styled-components'
import { rem } from 'polished'
import { getOfferTilePriceBlockLabelLayout, type OfferTilePriceBlockVariation } from 'lib/offer/offerTilePriceBlockExperiment'
import useIsHomepage from 'home/hooks/isHomepage'

interface Props {
  offer?: App.AnyOffer
  price: number
  memberPrice?: number
  discountPercentage?: number
  variation: OfferTilePriceBlockVariation
  offerConfig?: App.OfferLuxPlusConfig
}

const LabelSpacing = styled.div`
  margin-block-end: ${rem(4)};
`

function OfferTilePriceBlockSavingsLabel({ offer, price, memberPrice, discountPercentage, variation: priceBlockVariation, offerConfig }: Props) {
  const intl = useIntl()
  const isHomepage = useIsHomepage()
  const canViewMemberBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const displayedMode = useLuxPlusDisplayedMode({
    price,
    memberPrice: memberPrice ?? 0,
    offerConfig,
  })

  // CRO-7023: homepage variants keep the price treatment, but omit all savings badges.
  if (isHomepage) return null

  const saveAmount = memberPrice && memberPrice > 0 && memberPrice < price ? price - memberPrice : undefined

  const labelLayout = getOfferTilePriceBlockLabelLayout(offer, priceBlockVariation, displayedMode, canViewMemberBenefits)

  if (labelLayout === 'luxplus-savings' && saveAmount && isLEOffer(offer)) {
    // Reuse the shared savings/modal behaviour. Only treatment badges hide the
    // info icon to leave more room for the label across all tile surfaces.
    return <LabelSpacing><LuxPlusLabelWithModal type="member-price-offer" offer={offer} saveAmount={saveAmount} hideInfoIcon /></LabelSpacing>
  }

  if ((labelLayout === 'percentage-blue' || labelLayout === 'percentage-green') && discountPercentage && discountPercentage > 0) {
    return <LabelSpacing><Label kind="primary" variant={labelLayout === 'percentage-blue' ? 'lux-plus' : 'highlight'}>
      {intl.formatMessage(
        {
          id: 'z6PIe4gcIf_MXeIhW6hg',
          defaultMessage: 'Save up to {percentage}%',
          description: 'Savings percentage label above the hotel-only offer tile price in the price block experiment',
        },
        { percentage: discountPercentage },
      )}
    </Label>
    </LabelSpacing>
  }

  return null
}

export default OfferTilePriceBlockSavingsLabel
